import { render, staticRenderFns } from "./CalculatedSavings.vue?vue&type=template&id=18791b46&"
import script from "./CalculatedSavings.vue?vue&type=script&lang=js&"
export * from "./CalculatedSavings.vue?vue&type=script&lang=js&"
import style0 from "./CalculatedSavings.vue?vue&type=style&index=0&id=18791b46&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports